import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SearchFilterCard from "../../components/general/filter-card";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import AppContext from "../../context/app/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import Can from "../../utils/rbac/can";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import styles from "./style.module.scss";
import SliceTable from "../../components/slice/slice-table";
import PrizeContext from "../../context/prize/context";
import PrizeContextProvider from "../../context/prize/provider";
import PrizeTable from "../../components/prize/prize-table";
import PrizeFilter from "../../components/prize/prize-filter";
import { addSearchToURL, getFiltersFromURL, getKeywordFromURL } from "../../utils/helpers/url";
import { debounce } from "lodash";
interface IProps {
  children?: React.ReactNode;
}

const Prize: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();
  const [search, setSearch] = useState<string | undefined>(getKeywordFromURL());

  const { actions, loading, query } = useContext(PrizeContext);

  useEffect(() => {
          const filters = getFiltersFromURL();
          actions.setQuery({
              page: 1,
              perPage: 10,
              filters: filters,
              keyword:search
          });
      }, []);
      
          const debouncedSearch = debounce((value: string | undefined) => {
                  addSearchToURL(value);
                  actions.setSearch(value);
              }, 300);
          
              useEffect(() => {
                  debouncedSearch(search);
                  return () => {
                      debouncedSearch.cancel();
                  };
              }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("prize")}
        subTitle={t("prize_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/award/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_prize")}
            </Button>
          </Can>,
        ]}
      />

      <SearchFilterCard
        formId="prize-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          const searchParams = new URLSearchParams(location.search);
          searchParams.delete("keyword");
          Object.keys(getFiltersFromURL()).forEach((key) =>
            searchParams.delete(key)
          );
          navigate(`${location.pathname}`, { replace: true });
          actions.setQuery({
            page: 1,
            perPage: query?.perPage,
            keyword: undefined,
            filters: [],
          });
          const form = document.getElementById("prize-filter");
          if (form) {
            form.dispatchEvent(new Event("reset", { cancelable: true, bubbles: true }));
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <PrizeFilter></PrizeFilter>
      </SearchFilterCard>

      <PrizeTable />
    </div>
  );
};

const PrizePage = () => {
  return (
    <PrizeContextProvider>
      <Prize />
    </PrizeContextProvider>
  );
};
export default PrizePage;
